export class GetBlockedPolicyTypesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "blockedPolicyTypes",
            "baseName": "blockedPolicyTypes",
            "type": "Array<BackupPolicyType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetBlockedPolicyTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
